export default __webpack_public_path__ + "static/media/inventory_group.29a49dc8.svg";